import { createRoot } from "react-dom/client";
import { StoreProvider } from "@/app/storeProvider";
import React from "react";
import BotbPassMembersHomePage from "@/app/(custom-header)/botb-pass-members-home/page";

const root = createRoot(document.getElementById("botb-pass-members-page-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <BotbPassMembersHomePage />
    </StoreProvider>
  </React.StrictMode>
);
